import React, { useCallback, useEffect, useState } from 'react'
import { Button } from 'react-bootstrap'
import { Modal } from 'react-bootstrap'
import { getPlayerGameHistoryBlueday } from '../../../../../../Api/UserPanel/UserPanel'
import { BiLoaderCircle } from 'react-icons/bi'

interface Props {
    show: boolean
    onHide: () => void
    form: {
        name: string
    }
}

export const PlayerGameHistoryBlueday = ({ show, onHide, form }: Props) => {
    const [playerGameHistory, setPlayerGameHistory] = useState<any | null>([])
    const [loading, setLoading] = useState(false)


    // Pagination
    const [currentPage, setCurrentPage] = useState(1)
    const [noMorePages, setNoMorePages] = useState(false)
    const [totalPages, setTotalPages] = useState(0)

    const getGameHistory = useCallback(async (page: number = 1) => {
        setLoading(true)
        const response = await getPlayerGameHistoryBlueday({ name: form?.name?.trim(), page: page })

        if (response?.data?.data?.recordsTotal > 0 && response?.data?.data?.length === 0) {
            setNoMorePages(true)
        }
        if (response?.data?.recordsTotal > 0 && response?.data?.data?.length > 0) {
            setPlayerGameHistory(response.data.data)
            // Calculate total pages based on records total and items per page (10)
            setTotalPages(Math.ceil(response.data.recordsTotal / 100))
        }

        setLoading(false)
    }, [form.name])





    const handlePageChange = (newPage: number) => {
        setCurrentPage(newPage);
        getGameHistory(newPage);
    };


    const renderPaginationButtons = () => {
        const buttons = [];
        const maxButtons = 5;
        let startPage = Math.max(1, currentPage - Math.floor(maxButtons / 2));
        let endPage = Math.min(totalPages, startPage + maxButtons - 1);

        if (endPage - startPage + 1 < maxButtons) {
            startPage = Math.max(1, endPage - maxButtons + 1);
        }

        // Previous button
        buttons.push(
            <Button
                key="prev"
                variant="outline-secondary"
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
                className="mx-1"
            >
                &laquo;
            </Button>
        );

        // Page buttons
        for (let i = startPage; i <= endPage; i++) {
            buttons.push(
                <Button
                    key={i}
                    variant={currentPage === i ? "primary" : "outline-secondary"}
                    onClick={() => handlePageChange(i)}
                    className="mx-1"
                >
                    {i}
                </Button>
            );
        }

        // Next button
        buttons.push(
            <Button
                key="next"
                variant="outline-secondary"
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages || noMorePages}
                className="mx-1"
            >
                &raquo;
            </Button>
        );

        return buttons;
    };


    useEffect(() => {
        getGameHistory(currentPage)
    }, [getGameHistory])


    return (
        <Modal show={show} onHide={onHide} size='lg'>
            <Modal.Header closeButton>
                <Modal.Title>Historial de Juego {form.name}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='d-flex w-100'>
                    <span className='mb-4 text-center'>Últimos 3 meses</span>
                </div>
                {loading && <div className='d-flex justify-content-center my-5 gap-2 align-items-center'>
                    <div className='spin-animation d-flex align-items-center justify-content-center'>
                        <BiLoaderCircle size={20} />

                    </div>
                    <span>Cargando...</span>
                </div>}

                {!loading && playerGameHistory && (
                    <>
                        <div className="table-responsive mt-3">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>Fecha</th>
                                        <th>Proveedor</th>
                                        <th>Operacion</th>
                                        <th>Importe</th>
                                        <th>Saldo Anterior</th>
                                        <th>Saldo Posterior</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {playerGameHistory?.map((entry: any, index: number) => (
                                        <tr key={index}>
                                            <td>{entry[0]}</td>
                                            <td>{entry[1]}</td>
                                            <td>{entry[3]}</td>
                                            <td>{entry[4]}</td>

                                            <td>{entry[5]}</td>
                                            <td>{entry[6]}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            {
                                playerGameHistory?.length === 0 && <div className='d-flex justify-content-center my-5'>
                                    <span>No hay historial</span>
                                </div>
                            }
                        </div>
                        {playerGameHistory?.length > 0 && (
                            <div className="d-flex justify-content-center mt-3">
                                {renderPaginationButtons()}
                            </div>
                        )}
                    </>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Cerrar
                </Button>
            </Modal.Footer>
        </Modal>)
}
